import React from 'react';
import { BreadcrumbItem } from './components';
import tulkojumi from 'utils/tulkojumi';
import getHomeURL from 'utils/getHomeURL';
import {
  List,
} from './styled';

const Breadcrumbs = ({ items, teksti, truncationWidth, lang }) => {
  const homeURL = getHomeURL(lang);
  items = items.filter(item => item.path !== homeURL);
  return (
    <List>
      {
        items.map((item, i) => (
          <BreadcrumbItem
            key={i}
            path={item.path}
            hasChild={i < items.length - 1}
            truncationWidth={truncationWidth}
            title={/* item.path === homeURL ? tulkojumi(teksti, 'sakums') : */ item.title}
          />
        ))
      }
    </List>
  );
};

export default Breadcrumbs;



// WEBPACK FOOTER //
// ./src/elements/Breadcrumbs/Breadcrumbs.jsx